export const PRIMARY_COLOR = "#17165A";
export const SECONDARY_COLOR = "#FFD361";
export const TERTIARY_COLOR = "#FFFFFF";
